import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=f7627e9e&scoped=true&"
import script from "./PageNotFound.vue?vue&type=script&lang=ts&"
export * from "./PageNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7627e9e",
  null
  
)

export default component.exports